import React from "react";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";

const ArticleScreenGallery = ({ images }) => {
  if (!images || !images.length) return null;

  const galleryImages = images.map((img) => ({
    original: img,
    thumbnail: img,
  }));
  return (
    <div className="row">
      <div className="col-12">
        <ImageGallery items={galleryImages} />
      </div>
    </div>
  );
};

export default ArticleScreenGallery;



// WEBPACK FOOTER //
// ./src/screens/MainPage/ArticleScreenGallery.js